import { Component, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { FAQ, FAQReorder } from 'src/app/models/um/organization';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-faqorder',
  standalone: false,
  templateUrl: './faqorder.component.html',
  styleUrl: './faqorder.component.scss'
})
export class FaqorderComponent {
  @Input() public Content: any;
  content: any;
  ListOfFaqs: FAQ[] = [];
  allFaqs: any = [];
  action: Subject<any> = new Subject();
  module: any;
  Module: any;
  ISISTReorderd: boolean = false;
  ISEAPReorderd: boolean = false;
  ISGrantsReorderd: boolean = false;
  reorderFaqForm: any;
  ChangesHappend: boolean = false;
  ProgramList: any = [];
  faqsorderlist: FAQReorder[] = [];
  constructor(
    public modalRef: NgbActiveModal,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {

  }

  ngOnInit() {
    this.summaryService.getModuleList('api/common/getmoduleslist').subscribe((result) => {
      this.ProgramList = result;
    });

    this.reorderFaqForm = new UntypedFormGroup({
      Module: new UntypedFormControl("")
    });

  }

  programType(event: any): void {
    this.ISGrantsReorderd = false;
    this.ISISTReorderd = false;
    this.ISEAPReorderd = false;

    if(event){
      switch(event.value.value){
        case "2": 
          this.ISISTReorderd = true;
          break;
        case "4":
          this.ISGrantsReorderd = true;
          break;
        case "5":
          this.ISEAPReorderd = true;
          break;
      }
    }

    this.ListOfFaqs = [];
    this.allFaqs = this.Content.content.Data;
    this.allFaqs.forEach(ele => {
      if (ele.MODULES.match(event.value.label)) {
        this.ListOfFaqs.push(ele);
      }

      this.ListOfFaqs.map((ist) => ist.IST_SEQ_NO === null ? 0 : ist);
      this.ListOfFaqs.map((eap) => eap.EAP_SEQ_NO === null ? 0 : eap);
      this.ListOfFaqs.map((gr) => gr.GRANTS_SEQ_NO === null ? 0 : gr);

      this.Module = this.reorderFaqForm.controls['Module'].value.value;

      if (this.Module == "2") {
        this.ListOfFaqs.sort((a, b) => a.IST_SEQ_NO - b.IST_SEQ_NO);
      }
      else if (this.Module == "4") {
        this.ListOfFaqs.sort((a, b) => a.GRANTS_SEQ_NO - b.GRANTS_SEQ_NO)
      }
      else if (this.Module == "5") {
        this.ListOfFaqs.sort((a, b) => a.EAP_SEQ_NO - b.EAP_SEQ_NO);
      }
    })
  }

  SaveOrder() {
    if (this.reorderFaqForm.controls['Module'].value == "") {
      this.commonService.ValidationBanner("Please select Program.");
    }
    else {
      this.reorderFaqForm.controls['Module'].setValue(this.Module)
      const formdata = this.reorderFaqForm.getRawValue()
      formdata["FAQs"] = this.ListOfFaqs;
      formdata["ISGrantsReorderd"] = this.ISGrantsReorderd;
      formdata["ISISTReorderd"] = this.ISISTReorderd;
      formdata["ISEAPReorderd"] = this.ISEAPReorderd
      this.summaryService.faqreordersave("api/faq/reorderfaqs", formdata).subscribe(result => { //, null, fAQs
        if (result){
          if(result.Status == "MODIFIED") //Fixing Existing Issue
          this.commonService.SuccessBanner("Reorder saved successfully")
        else  if(result.Status == "NOT MODIFIED")
         this.commonService.ValidationBanner("No changes have been performed");
           this.modalRef.close(result.FAQs);
        }
      });
    }

  }

  Close() {
    this.canExit().then(x => {
      this.modalRef.dismiss();
    });
  }

  listSorted(event: any) {
    this.ChangesHappend = true;
  }

  canExit() {
    if (this.ChangesHappend) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
